import { FormBase } from "core/components";

export default class NikoPatientInsuranceEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "insuranceId",
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.INSURANCE_PLACEHOLDER',
                    rules: "required|string",
                },
                {
                    name: "policyNo",
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.POLICY_NUMBER',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.POLICY_NUMBER_PLACEHOLDER',
                    rules: "required|string",
                },
                {
                    name: "startDate",
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.START_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.START_DATE_PLACEHOLDER',
                    rules: "required",
                },
                {
                    name: "endDate",
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.END_DATE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.END_DATE_PLACEHOLDER',
                },
                {
                    name: "oldEndDate",
                    label: "End Date",
                    placeholder: "Select Date",
                },
                {
                    name: "oldEndDateUnavailable",
                    label: "End Date Unavailable",
                    type: "checkbox",
                    value: false,
                },
                {
                    name: "relationship",
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.RELATIONSHIP_PLACEHOLDER',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_PATIENT_ADD_NOTE_MODAL.RELATIONSHIP_PLACEHOLDER',
                    rules: "string",
                },
                {
                    name: "insuredFirstName",
                    label: "Insured First Name",
                    placeholder: "Enter Insured First Name",
                    rules: "string",
                },
                {
                    name: "insuredLastName",
                    label: "Insured Last Name",
                    placeholder: "Enter Insured Last Name",
                    rules: "string",
                },
                {
                    name: "insuredDOB",
                    label: "Insured DOB",
                    placeholder: "MM/DD/YYYY",
                },
                {
                    name: "insuredGender",
                    label: "Insured Gender",
                    placeholder: "Select Gender",
                    rules: "string",
                }
            ],
        };
    }
}